<template>
  <div class="Ghidorah">
    <div class="banner-wrap">
      <div class="banner-text">
        <p>企业 VI 设计</p>
        <p>Enterprise VI Design</p>
      </div>
      <!-- <img src="images/king1.png" alt=""> -->
    </div>
    <div class="service-wrap">
      <main-title title="业务介绍" color="#ec1e24"></main-title>
      <ul class="service-list">
        <li class="service-item" v-for="item in serviceList" :key="item.id">
          <div class="serv-show">
            <p class="serv-title">{{ item.servTitle }}</p>
          </div>
          <div class="serv-hover">
            <p class="serv-title">{{ item.servTitle }}</p>
            <p class="serv-text">{{ item.servText }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import mainTitle from '@/components/title'
export default {
  name: 'ghidorah',
  components: {
    mainTitle
  },
  data() {
    return {
      bannerimg: './images/whxq/banner.jpg',
      serviceList: [
        {
          id: 1,
          servTitle: '品牌设计',
          servText: '打造独特视觉与情感识别，通过标志、色彩和字体构建一致的品牌形象，增强市场辨识度'
        },
        {
          id: 2,
          servTitle: '创意设计',
          servText: '融合创新思维与美学，创造引人注目的图形、多媒体内容，提供独特且有影响力的视觉解决方案'
        },
        {
          id: 3,
          servTitle: '企业 VI',
          servText: '统一视觉标准，包括标志、名片等，确保品牌形象的一致性和专业性，提升公众认知度'
        },
        {
          id: 4,
          servTitle: '产品设计',
          servText: '结合美学与功能性，开发实用且吸引人的商品，优化用户体验，提升产品市场竞争力'
        },
        {
          id: 5,
          servTitle: '宣传设计',
          servText: '制作吸睛的营销材料，如海报、手册，有效传达信息，激发目标受众的兴趣和行动'
        },
      ],
    }
  }
}
</script>

<style lang="scss" scoped>
.Ghidorah {
  margin-top: 80px;
  padding-bottom: 80px;
}

.banner-wrap {
  position: relative;
  width: 100%;
  height: 600px;
  margin-bottom: 50px;
  background-color: #ec1c24;
  .banner-text {
    position: absolute;
    top: 30%;
    left: 10%;
  }
  p {
    font-size: 68px;
    color: #fff;
    font-weight: bold;
    line-height: 110px;
  }

  img {
    position: absolute;
    right: 10%;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 500px;
    height: 500px;
    transform: rotate(-8deg);
  }
}
.service-wrap {
  width: 80%;
  margin: auto;
}
.service-list {
  display: flex;
  position: relative;
  width: 100%;
  height: 350px;
  margin-top: 45px;
  justify-content: space-between;

  .service-item {
    width: 18%;
    height: 100%;
    background-color: #333;

    &:hover {
      .serv-show {
        display: none;
      }

      .serv-hover {
        display: block;
      }
    }
  }

  .serv-show {
    display: block;
    height: 100%;
    line-height: 350px;
    text-align: center;
    background-image: linear-gradient(to bottom right, #d0905c, #ec1c24);

    .serv-icon {
      display: inline-block;
      width: 42px;
      height: 48px;
      margin-bottom: 22px;
      background-size: cover;
    }

    .serv-title {
      color: #fff;
      font-weight: bold;
      font-size: 32px;
    }
  }

  .serv-hover {
    display: none;
    width: 100%;
    height: 100%;
    background-color: #e57e2d;

    .serv-title {
      position: relative;
      height: 90px;
      line-height: 90px;
      text-align: center;
      font-weight: 500;
      color: #fff;
      font-size: 24px;

      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 10%;
        right: 10%;
        border: 1px dashed #fff;
        opacity: .4;
      }
    }

    .serv-text {
      padding: 18px 30px;
      font-size: 18px;
      color: #fff;
      text-align: justify;
    }
  }
}
</style>